import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import showToast from "../../../services/toast";
import { useTranslation } from "react-i18next";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import React from "react";
import PagesHeader from "ah_utility/PagesHeader";
export var PaymentHeader = function (props) {
    var t = useTranslation().t;
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: props.loadingCreatePolicy || props.loading, seeToast: props.seeToast, showToast: showToast, setSeeToast: props.setSeeToast, titleLoading: props.loadingCreatePolicy ? "Generando pago" : "Cargando datos" }), _jsx(PagesHeader, { titlePage: "Confirmación de pago", hideStep: false, steps: props.steps })] }));
};
